import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";
import { ENABLED_CURRENCIES, currencyMeta } from "../lib/pricingConfig";

export const CurrencyPill = ({ testid = "currency-pill" }) => {
  const { currency, auto, setCurrency } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", close); return () => document.removeEventListener("pointerdown", close);
  }, [open]);
  const pick = (code) => { setCurrency(code); setOpen(false); };
  return (
    <div className="relative inline-block notranslate" translate="no" ref={ref}>
      <button type="button" className="balance-pill" onClick={() => setOpen((o) => !o)} aria-haspopup="listbox" aria-expanded={open} data-testid={testid} data-currency={currency}>
        {currencyMeta(currency).symbol.trim()} <ChevronDown size={12} />
      </button>
      {open && (
        <ul className="currency-menu" role="listbox" data-testid={`${testid}-menu`}>
          <li><button type="button" role="option" aria-selected={auto} onClick={() => pick("auto")} data-testid={`${testid}-option-auto`}>Auto {auto && <Check size={12} />}</button></li>
          {ENABLED_CURRENCIES.map((c) => (
            <li key={c.code}><button type="button" role="option" aria-selected={!auto && c.code === currency} onClick={() => pick(c.code)} data-testid={`${testid}-option-${c.code.toLowerCase()}`}>
              <span>{c.symbol.trim()}</span> <span className="text-muted">{c.code}</span> {!auto && c.code === currency && <Check size={12} />}
            </button></li>
          ))}
        </ul>
      )}
    </div>
  );
};
